import { Pipe, PipeTransform } from '@angular/core';
import { formatBirth } from 'src/app/utils/date';

@Pipe({
  name: 'birth',
})
export class BirthPipe implements PipeTransform {
  transform(value: string, ...args: unknown[]): unknown {
    if (!value) return null;
    value = value.replace(/[^0-9]/g, '');
    return formatBirth(value);
  }
}
